import React from 'lib/react';

import { EVGrid, EVSkeleton } from 'lib/components';

import AddressInformationLoaderStyles from './AddressInformationLoaderStyles';

export default function AddressInformationLoader() {
  const classes = AddressInformationLoaderStyles();
  return (
    <EVGrid container item direction="column">
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.heading} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.inputField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.inputField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.inputField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid container item className={classes.phoneContainer} direction="row">
        <EVGrid className={classes.fieldContainer} item>
          <EVSkeleton className={classes.phoneField} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid className={classes.fieldContainer} item>
          <EVSkeleton className={classes.extField} animation="wave" variant="rect" />
        </EVGrid>
      </EVGrid>
      <EVGrid container item className={classes.secondaryPhoneContainer} direction="row">
        <EVGrid className={classes.fieldContainer} item>
          <EVSkeleton className={classes.phoneField} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid className={classes.fieldContainer} item>
          <EVSkeleton className={classes.extField} animation="wave" variant="rect" />
        </EVGrid>
      </EVGrid>
      <EVGrid className={classes.fieldContainer} item>
        <EVSkeleton className={classes.inputField} animation="wave" variant="rect" />
      </EVGrid>
      <EVGrid container item direction="row" className={classes.cityStateContainer}>
        <EVGrid className={classes.cityContainer} item>
          <EVSkeleton className={classes.cityStateContainerField} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid className={classes.stateContainer} item>
          <EVSkeleton className={classes.cityStateContainerField} animation="wave" variant="rect" />
        </EVGrid>
        <EVGrid className={classes.zipContainer} item>
          <EVSkeleton className={classes.cityStateContainerField} animation="wave" variant="rect" />
        </EVGrid>
      </EVGrid>
      <EVGrid item>
        <EVSkeleton className={classes.button} animation="wave" variant="rect" />
      </EVGrid>
    </EVGrid>
  );
}
